import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import {Container, Row} from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';


export const UsuarioDP = ({rowData}) => (
    <Container fluid className="candado-container">
        <Row className="bg-silver p-3 flex-column flex-md-row">
            {/* <Col className="mb-3 mb-md-0">
                <table>
                    <thead>
                    <tr>
                        <td>Cantidad</td>
                        <td>Precio Unitario</td>
                        <td>Tipo Repuesto</td>
                        <td>Marca</td>
                        <td>Modelo</td>
                        <td>Version</td>
                    </tr>
                    </thead>
                    <tbody>
                    {rowData.items?.map((item, idx) => (
                        <tr>
                            <td className="product_accent--sub">{item.cantidad}</td>
                            <td className="product_accent--sub"><NumberFormat prefix={'$'} value={item.precioUnitario}
                                                                              displayType={'text'} thousandSeparator="."
                                                                              decimalSeparator=","/></td>
                            <td className="product_accent--sub">{item.tipoRepuesto?.nombre}</td>
                            <td className="product_accent--sub">{item.marca?.nombre}</td>
                            <td className="product_accent--sub">{item.modelo?.nombre}</td>
                            <td className="product_accent--sub">{item.version?.nombre}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </Col> */}

        </Row>
    </Container>
);


export const alertConfirm = (titulo,mensajeCuerpo,textoBotonSi,textoBotonNo,cancel,confirm,elementOnConfirm,simple,tipo=null,showConfirm=true) => {
    return(

          <div className="th_warning">
          <SweetAlert
            type={tipo?tipo:'warning'}
            showCancel={true}
            showConfirm={showConfirm}
            showCloseButton={true}
            closeOnClickOutside={false}
            title={titulo}
            confirmBtnText={textoBotonSi}
            cancelBtnText={textoBotonNo}
            onCancel={()=>cancel()}
            onConfirm={() => simple?confirm():confirm(elementOnConfirm,cancel)}
          >
              <hr></hr>
              <div className="text-dark">
                  {mensajeCuerpo}
              </div>
              <hr></hr>

          </SweetAlert>
          </div>
        )};